module.exports = __webpack_public_path__ + "img/zflogo.21cc6e24.png";